import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class HomePageExControllerSvr {
    constructor() {
        this.baseurl = 'HomePageExControllerSvr.assx/';
    }

    /**
     * 获取投诉情况
     * token:String
     */
    GetComplaintsSituation(token){
        return request.post(this.baseurl + 'GetComplaintsSituation', Qs.stringify({ token:token }));
    }

    /**
     * 办事效率列表
     * token:String
     */
    GetEfficiencyList(token){
        return request.post(this.baseurl + 'GetEfficiencyList', Qs.stringify({ token:token }));
    }

    /**
     * 获取物业区域
     * token:String, eaAreaCodes:String
     */
    GetEaArea(token, eaAreaCodes){
        return request.post(this.baseurl + 'GetEaArea', Qs.stringify({ token:token, eaAreaCodes:eaAreaCodes }));
    }

    /**
     * 获取业委会与物业区域关联列表
     * token:String
     */
    GetAreaHaveOwnerTeamList(token){
        return request.post(this.baseurl + 'GetAreaHaveOwnerTeamList', Qs.stringify({ token:token }));
    }

    /**
     * 获取维修资金使用情况
     * token:String
     */
    GetUseFunds(token){
        return request.post(this.baseurl + 'GetUseFunds', Qs.stringify({ token:token }));
    }

    /**
     * 获取用户报修情况
     * token:String
     */
    GetRepairSituation(token){
        return request.post(this.baseurl + 'GetRepairSituation', Qs.stringify({ token:token }));
    }

    /**
     * 获取全市投诉情况
     * token:String
     */
    GetALLComplaintsSituation(token){
        return request.post(this.baseurl + 'GetALLComplaintsSituation', Qs.stringify({ token:token }));
    }

    /**
     * 物业区域概况
     * token:String
     */
    GetAreaSituation(token){
        return request.post(this.baseurl + 'GetAreaSituation', Qs.stringify({ token:token }));
    }

    /**
     * 获取物业公司与物业区域关联列表
     * token:String
     */
    GetAreaHaveRealtyMgeComList(token){
        return request.post(this.baseurl + 'GetAreaHaveRealtyMgeComList', Qs.stringify({ token:token }));
    }
}